import { Directive, Input, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appDateValidate]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DateValidateDirective),
      multi: true
    }
  ]
})
export class DateValidateDirective implements Validator {
  @Input('dateValidateMinDate') minDate: string;
  @Input('dateValidateMaxDate') maxDate: string;
  @Input('dateValidateIgnoreMinMax') ignoreMinMax: boolean;
  @Input('dateValidateIndex') dateValidateIndex: string;

  validate(control: AbstractControl): ValidationErrors | null {
    const dateStr = control.value;

    // Check for null or empty value
    if (!dateStr) {
      return { required: { valid: false } }; 
    }

    const minDate = this.normalizeDate(new Date(this.minDate));
    const maxDate = this.normalizeDate(new Date(this.maxDate));
    const date = this.normalizeDate(new Date(dateStr));

    if (this.ignoreMinMax) {
      return null;
    }

    if (date < minDate || date > maxDate) {
      return { dateRange: { valid: false } };
    }

    return null;
  }

  private normalizeDate(date: Date): Date {
    const normalizedDate = new Date(date);
    normalizedDate.setHours(0, 0, 0, 0);
    return normalizedDate;
  }

}